var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBounce = function SvgBounce(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M501.333 128H394.667c-5.896 0-10.667 4.771-10.667 10.667V160c0 5.896 4.771 10.667 10.667 10.667h42.279L255.72 333.966 32.286 130.781c-4.357-3.961-11.111-3.655-15.089.682L2.794 147.171c-3.978 4.339-3.672 11.068.685 15.03l237.773 216.231c4.078 3.72 9.241 5.569 14.405 5.569 5.131 0 10.263-1.829 14.331-5.506l199.345-179.639v46.479c0 5.896 4.771 10.667 10.667 10.667h21.333c5.896 0 10.667-4.771 10.667-10.667V138.667c0-5.896-4.771-10.667-10.667-10.667z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBounce, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bounce.4d4d3fa4.svg";
export { ForwardRef as ReactComponent };